import {ResponsiveHeader} from '@geomatico/geocomponents';
import HomeIcon from '@mui/icons-material/Home';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import type {FC} from 'react';
import {LogoTalptechBlanco} from 'talptech-gis-components';

//TYPES
type Props = {
  onStartIconClick?: () => void;
  onHomeClick?: () => void;
};

export const Header: FC<Props> = ({onStartIconClick, onHomeClick}) => {
  return (
    <ResponsiveHeader
      startIcon={onStartIconClick && <MenuIcon />}
      logo={<LogoTalptechBlanco width="50%" />}
      isStartIconCloseable={false}
      width="100%"
      onStartIconClick={onStartIconClick}
      sx={{'& .ResponsiveHeader-logo': {ml: onStartIconClick ? 0 : 2}}}
    >
      {onHomeClick && (
        <IconButton onClick={onHomeClick} size="large" edge="end" sx={{color: 'common.white'}} aria-label="home">
          <HomeIcon />
        </IconButton>
      )}
    </ResponsiveHeader>
  );
};
export default Header;
